import React from 'react';

import WrapperWidget from '../Wrapper';
import InputText from '../../../FormFields/Text';
import withFieldActions from '../withFieldActions';
import InputSelect from '../../../FormFields/Select';


import './style.scss';
import Checkbox from '../../../FormFields/Checkbox';
import ConfigService from "../../../../Services/api/Config";

export class PageBreakWidget extends React.PureComponent {

  renderConfig = (internalField, changeFieldValue, changeFieldError) => {
    const {api,field} = this.props;
    return (
      <div className='Widget_Form_Config'>
        <InputText label='Label' required value={ api.getFieldsVerbiage(internalField, 'label') }
                   onChange={ (v) => changeFieldValue('label', v) } error={ internalField.errors['label'] }
                   onError={ (error) => changeFieldError('label', error) }/>
        <InputSelect label='Display Width' 
                    value={ internalField.display_width }
                    onChange={ (v) => changeFieldValue('display_width', v.value)
                    }
                    options={field.displayWidthOptions && field.displayWidthOptions.map((option) => {
                      return { value: option.value, label: option.value };
                    })}/>
        <div className="InputCheckboxesWrapper">
          <Checkbox onChange={ (v) => changeFieldValue('lockDDR', v) } label='Lock in DDR'
                    checked={ internalField.lockDDR }
                    className='InputCheckbox_Block'/>
        </div>
      </div>
    );
  };

  render() {
    const { field, renderForm, api } = this.props;
    const props = {
      ...this.props,
      renderForm: () => renderForm(this.renderConfig),
      formTitle: 'Page Break',
      headerHidden: true
    };
    return (
      <WrapperWidget {...props}>
        <div className='PageBreakWidget'>
          <div className='Widget_Label' style={ { color: ConfigService.getColor('tertiaryColor') } }>
            {api ? api.getFieldsVerbiage(field, 'description') : field.label }
          </div>
          <hr/>
        </div>
      </WrapperWidget>
    );
  }
}

export const PageBreakWidgetEditable = withFieldActions(PageBreakWidget);